<header>
  <dx-toolbar class="header-toolbar">
    <dxi-toolbar-item
      *ngIf="menuToggleEnabled"
      location="before"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }"
    >
    </dxi-toolbar-item>
    <dxi-toolbar-item location="before" locateInMenu="never">
      <div *dxTemplate>
        <a class="header-brand" routerLink="/" aria-label="IONICS — inicio">
          <img src="assets/img/ionics-logo.gif" alt="IONICS"/>
        </a>
      </div>
    </dxi-toolbar-item>

    <!-- Back / Forward — patron browser/Linear/Notion. Atajos Ctrl/⌘+[ y +].
         Back deshabilitado si no hubo nav previa en sesion (history.back podria
         sacar al user de la app). Forward siempre habilitado — history.forward
         es no-op si no hay forward stack. -->
    <dxi-toolbar-item location="before" locateInMenu="auto" cssClass="navigation-slot">
      <div *dxTemplate>
        <div class="header-nav-buttons">
          <button type="button"
                  class="header-nav-btn"
                  [disabled]="!canGoBack()"
                  (click)="goBack()"
                  [attr.aria-label]="'appHeader.atras' | translate"
                  [title]="('appHeader.atras' | translate) + ' (' + (isMac() ? '⌘' : 'Ctrl') + '+[)'">
            <app-icon name="chevronleft" [size]="16"></app-icon>
          </button>
          <button type="button"
                  class="header-nav-btn"
                  (click)="goForward()"
                  [attr.aria-label]="'appHeader.adelante' | translate"
                  [title]="('appHeader.adelante' | translate) + ' (' + (isMac() ? '⌘' : 'Ctrl') + '+])'">
            <app-icon name="chevronright" [size]="16"></app-icon>
          </button>
        </div>
      </div>
    </dxi-toolbar-item>

    <!-- Breadcrumb dinamico — solo renderiza si hay trail (oculto en /home, /auth, etc.).
         locateInMenu="auto" hace que se mueva al overflow menu en pantallas chicas. -->
    <dxi-toolbar-item location="before" locateInMenu="auto" cssClass="breadcrumb-slot">
      <div *dxTemplate>
        <nav class="header-breadcrumb"
             *ngIf="breadcrumb.trail().length > 0"
             [attr.aria-label]="'appHeader.breadcrumb.label' | translate">
          <ol>
            <li *ngFor="let seg of breadcrumb.trail(); let i = index; let last = last"
                class="bc-segment"
                [class.is-current]="last">
              <a *ngIf="seg.path && !last"
                 class="bc-link"
                 [routerLink]="seg.path">
                <app-icon *ngIf="seg.icon && i === 0" [name]="seg.icon" [size]="13"></app-icon>
                <span class="bc-label">{{ seg.label }}</span>
              </a>
              <span *ngIf="!seg.path || last" class="bc-current" aria-current="page">
                <app-icon *ngIf="seg.icon && i === 0" [name]="seg.icon" [size]="13"></app-icon>
                <span class="bc-label">{{ seg.label }}</span>
              </span>
              <span *ngIf="!last" class="bc-sep" aria-hidden="true">/</span>
            </li>
          </ol>
        </nav>
      </div>
    </dxi-toolbar-item>

    <!-- Search trigger — al click abre el Command Palette (⌘K). NO es un input
         de búsqueda local; es un atajo visual al palette global. -->
    <dxi-toolbar-item location="after" locateInMenu="auto" cssClass="search-slot">
      <div *dxTemplate>
        <button type="button"
                class="cmd-search-trigger"
                (click)="openCommandPalette()"
                [attr.aria-label]="'appHeader.abrirBuscador' | translate">
          <app-icon name="search" class="cmd-search-icon" [size]="15"></app-icon>
          <span class="cmd-search-text">{{ 'appHeader.buscarGlobal' | translate }}</span>
          <span class="cmd-search-kbd" aria-hidden="true">
            <kbd>{{ isMac() ? '⌘' : 'Ctrl' }}</kbd>
            <kbd>K</kbd>
          </span>
        </button>
      </div>
    </dxi-toolbar-item>

    <!-- Slot de actions contextuales — cada pagina puede inyectar botones aqui
         via HeaderActionsService. Auto-clear en cada navegacion. -->
    <dxi-toolbar-item location="after" locateInMenu="auto" cssClass="page-actions-slot"
                      *ngIf="headerActions.template() as actionsTpl">
      <div *dxTemplate>
        <div class="page-actions">
          <ng-container *ngTemplateOutlet="actionsTpl"></ng-container>
        </div>
      </div>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after" locateInMenu="never" cssClass="actions-divider">
      <div *dxTemplate>
        <span class="divider-line" aria-hidden="true"></span>
      </div>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after" locateInMenu="never">
      <div *dxTemplate>
        <theme-switcher class="action-icon-slot"></theme-switcher>
      </div>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after" locateInMenu="auto">
      <div *dxTemplate>
        <language-switcher></language-switcher>
      </div>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after">
      <div *dxTemplate>
        <div class="action-icon chat-action"
             (click)="irAlChat()"
             (keydown.enter)="irAlChat()"
             role="button" tabindex="0"
             [attr.aria-label]="('sidebar.abrirChat' | translate) + (totalChatNoLeidos() > 0 ? ' (' + totalChatNoLeidos() + ' ' + ('sidebar.sinLeer' | translate) + ')' : '')"
             [title]="'sidebar.chat' | translate">
          <app-icon name="message" [size]="18"></app-icon>
          <span class="action-badge action-badge-chat" *ngIf="totalChatNoLeidos() > 0">
            {{ totalChatNoLeidos() }}
          </span>
        </div>
      </div>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after">
      <div *dxTemplate>
        <!-- Bell — toggle de push browser notifications.
             - ON (push.granted o pushEnabled): bell relleno + el user puede silenciar
             - OFF: bell outline; al click pide permission y activa
             NO muestra badge de chat (ese vive en el chat-action) — el bell es
             un toggle de canal, no un contador de no leidos. El slash visual
             aparece cuando push esta explicitamente OFF post-decision del user. -->
        <div class="action-icon bell-action"
             [class.is-on]="notifs.pushEnabled()"
             role="button" tabindex="0"
             [attr.aria-pressed]="notifs.pushEnabled()"
             [attr.aria-label]="(notifs.pushEnabled() ? 'appHeader.silenciar' : 'appHeader.activarNotifs') | translate"
             [title]="(notifs.pushEnabled() ? 'appHeader.silenciar' : 'appHeader.activarNotifs') | translate"
             (click)="toggleBrowserNotifs()"
             (keydown.enter)="toggleBrowserNotifs()">
          <app-icon name="bell" [size]="18"></app-icon>
          <span class="action-badge-mute" *ngIf="!notifs.pushEnabled() && notifs.browserPermission() !== 'default'" aria-hidden="true"></span>
        </div>
      </div>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after" locateInMenu="never" cssClass="actions-divider">
      <div *dxTemplate>
        <span class="divider-line" aria-hidden="true"></span>
      </div>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
      <div *dxTemplate="let data of 'item'">
        <user-panel
          [user]="user"
          [menuItems]="userMenuItems"
          [online]="isOnline()"
          menuMode="context"
        ></user-panel>
      </div>
    </dxi-toolbar-item>
    <div *dxTemplate="let data of 'menuItem'">
      <user-panel
        [user]="user"
        [menuItems]="userMenuItems"
        menuMode="list"
      ></user-panel>
    </div>
  </dx-toolbar>
</header>
